module.exports = __webpack_public_path__ + "img/LT112046615.bf98efee.png";